(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edenika-home-journey"] && !Shopify.designMode) return;
  try {
    

(function(){
  function revealEdenika(){
    var home=document.querySelector('.eb-home');
    if(!home||home.dataset.revealReady)return;
    home.dataset.revealReady='true';
    var motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    if(motion.matches||!('IntersectionObserver' in window))return;
    var items=Array.from(home.querySelectorAll('.eb-collection,.eb-product,.eb-botanical,.eb-ritual,.eb-massage,.eb-heading,.eb-faq-intro,.eb-routine-steps li'));
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.remove('eb-awaiting');observer.unobserve(entry.target);}});
    },{threshold:0.08});
    items.forEach(function(item,index){
      if(item.getBoundingClientRect().top<window.innerHeight)return;
      item.style.setProperty('--eb-reveal-delay',(index%4)*45+'ms');
      item.classList.add('eb-scroll-reveal','eb-awaiting');
      observer.observe(item);
    });
    motion.addEventListener('change',function(event){if(event.matches){observer.disconnect();items.forEach(function(item){item.classList.remove('eb-awaiting');});}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',revealEdenika,{once:true});else revealEdenika();
  document.addEventListener('shopify:section:load',revealEdenika);
})();


(function(){function init(){document.querySelectorAll('.eb-carousel-controls').forEach(function(control){if(control.dataset.ready)return;control.dataset.ready='true';var track=document.getElementById(control.dataset.carousel);if(!track)return;var buttons=control.querySelectorAll('button'),count=control.querySelector('.eb-carousel-count');function update(){var max=track.scrollWidth-track.clientWidth;var step=track.children[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);var index=Math.min(track.children.length,Math.round(track.scrollLeft/step)+1);count.textContent=index+' / '+(Math.ceil(Math.max(0,max-1)/step)+1);buttons[0].disabled=track.scrollLeft<2;buttons[1].disabled=track.scrollLeft>=max-2;}buttons.forEach(function(button){button.addEventListener('click',function(){var step=track.children[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);track.scrollBy({left:Number(button.dataset.step)*step,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});});track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);update();});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);})();


  } catch(e) { console.error(e); }
})();
})();
